import { Injectable } from '@angular/core';
import { AnalyticsPageModel } from '../../model/analyticsPage';
import { JourneyService } from '../journey/journey.service';
import { TrackTypes } from '../journey/tracks/model/track-types';

@Injectable({
    providedIn: 'root'
})

export class AnalyticsPageService {


    constructor(private journeyService: JourneyService) {
    }

    public setAnalyticsPage(): AnalyticsPageModel {

        const journey = this.journeyService.journey;
        const analyticsPage = new AnalyticsPageModel();

        switch (journey) {
            case TrackTypes.BASIC:
                this.setBasicAnalyticsCommon(analyticsPage);
                this.setBasicAnalyticsPersonal(analyticsPage);
                this.setBasicAnalyticsMarital(analyticsPage);
                this.setBasicAnalyticsAddress(analyticsPage);
                this.setBasicAnalyticsProfessional(analyticsPage);
                this.setBasicAnalyticsIncome(analyticsPage);
                return analyticsPage;
            case TrackTypes.BASIC_V2:
                this.setBasicAnalyticsCommon(analyticsPage);
                this.setBasicAnalyticsPersonal(analyticsPage);
                this.setBasicAnalyticsMarital(analyticsPage);
                this.setBasicAnalyticsAddress(analyticsPage);
                this.setBasicAnalyticsProfessional(analyticsPage);
                this.setBasicAnalyticsIncome(analyticsPage);
                return analyticsPage;
            case TrackTypes.BASIC_PROFILE_V2:
                this.setBasicAnalyticsCommon(analyticsPage);
                this.setBasicAnalyticsPersonal(analyticsPage);
                return analyticsPage;
            case TrackTypes.BASIC_PERSONAL_V2:
                this.setBasicAnalyticsCommon(analyticsPage);
                this.setBasicAnalyticsPersonal(analyticsPage);
                return analyticsPage;
            case TrackTypes.BASIC_MARITAL_V2:
                this.setBasicAnalyticsCommon(analyticsPage);
                this.setBasicAnalyticsMarital(analyticsPage);
                return analyticsPage;
            case TrackTypes.BASIC_ADDRESS_V2:
                this.setBasicAnalyticsCommon(analyticsPage);
                this.setBasicAnalyticsAddress(analyticsPage);
                return analyticsPage;
            case TrackTypes.BASIC_PROFESSIONAL_V2:
                this.setBasicAnalyticsCommon(analyticsPage);
                this.setBasicAnalyticsProfessional(analyticsPage);
                return analyticsPage;
            case TrackTypes.BASIC_INCOME_V2:
                this.setBasicAnalyticsCommon(analyticsPage);
                this.setBasicAnalyticsIncome(analyticsPage);
                return analyticsPage;
            case TrackTypes.UPDATE_REGISTRATION:
                this.setUpdateRegistrationAnalyticsCommon(analyticsPage);
                this.setUpdateRegistrationAnalyticsPersonal(analyticsPage);
                this.setUpdateRegistrationAnalyticsMarital(analyticsPage);
                this.setUpdateRegistrationAnalyticsAddress(analyticsPage);
                this.setUpdateRegistrationAnalyticsProfessional(analyticsPage);
                this.setUpdateRegistrationAnalyticsIncome(analyticsPage);
                return analyticsPage;
            case TrackTypes.UPDATE_PROFILE:
                this.setUpdateRegistrationAnalyticsCommon(analyticsPage);
                this.setUpdateRegistrationAnalyticsPersonal(analyticsPage);
                return analyticsPage;
            case TrackTypes.UPDATE_MARITAL:
                this.setUpdateRegistrationAnalyticsCommon(analyticsPage);
                this.setUpdateRegistrationAnalyticsMarital(analyticsPage);
                return analyticsPage;
            case TrackTypes.UPDATE_ADDRESS:
                this.setUpdateRegistrationAnalyticsCommon(analyticsPage);
                this.setUpdateRegistrationAnalyticsAddress(analyticsPage);
                return analyticsPage;
            case TrackTypes.UPDATE_PROFESSIONAL:
                this.setUpdateRegistrationAnalyticsCommon(analyticsPage);
                this.setUpdateRegistrationAnalyticsProfessional(analyticsPage);
                return analyticsPage;
            case TrackTypes.UPDATE_INCOME:
                this.setUpdateRegistrationAnalyticsCommon(analyticsPage);
                this.setUpdateRegistrationAnalyticsIncome(analyticsPage);
                return analyticsPage;
            case TrackTypes.UPDATE_INCOME_CONTA_ION:
                this.setUpdateRegistrationAnalyticsCommon(analyticsPage);
                this.setUpdateRegistrationAnalyticsIncome(analyticsPage);
                return analyticsPage;
            case TrackTypes.CONTA_ION:
                this.setContaionAnalyticsCommon(analyticsPage);
                this.setContaionAnalyticsPersonal(analyticsPage);
                this.setContaionAnalyticsMarital(analyticsPage);
                this.setContaionAnalyticsAddress(analyticsPage);
                this.setContaionAnalyticsProfessiotal(analyticsPage);
                this.setContaionAnalyticsIncome(analyticsPage);
                return analyticsPage;
            case TrackTypes.CONTA_ION_INCOME:
                this.setContaionAnalyticsCommon(analyticsPage);
                this.setContaionAnalyticsIncome(analyticsPage);
                return analyticsPage;
            case TrackTypes.CONTA_ION_ADDRESS:
                this.setContaionAnalyticsCommon(analyticsPage);
                this.setContaionAnalyticsAddress(analyticsPage);
                return analyticsPage;
            case TrackTypes.CONTA_ION_MARITAL:
                this.setContaionAnalyticsCommon(analyticsPage);
                this.setContaionAnalyticsMarital(analyticsPage);
                return analyticsPage;
            case TrackTypes.CONTA_ION_PROFESSIONAL:
                this.setContaionAnalyticsCommon(analyticsPage);
                this.setContaionAnalyticsProfessiotal(analyticsPage);
                return analyticsPage;
            case TrackTypes.CONTA_ION_PERSONAL:
                this.setContaionAnalyticsCommon(analyticsPage);
                this.setContaionAnalyticsPersonal(analyticsPage);
                return analyticsPage;
            default:
                break;
        }

    }

    private setContaionAnalyticsPersonal(analyticsPage) {
        analyticsPage.documentType = 'ION:NL:Cadastro:DadosPessoais:EscolhaDocumento';
        analyticsPage.documentName = 'ION:NL:Cadastro:DadosPessoais:InsiraSeuNome';
        analyticsPage.documentNumber = 'ION:NL:Cadastro:DadosPessoais:InsiraSeu';
        analyticsPage.documentIssuing = 'ION:NL:Cadastro:DadosPessoais:OrgaoExpedidor';
        analyticsPage.documentExpeditionState = 'ION:NL:Cadastro:DadosPessoais:EstadoExpedicao';
        analyticsPage.birthCity = 'ION:NL:Cadastro:DadosPessoais:CidadeQueNasceu';
        analyticsPage.birthCountry = 'ION:NL:Cadastro:DadosPessoais:PaisQueNasceu';
        analyticsPage.birthDate = 'ION:NL:Cadastro:DadosPessoais:QuandoNasceu';
        analyticsPage.birthState = 'ION:NL:Cadastro:DadosPessoais:EstadoQueNasceu';
        analyticsPage.documentExpeditionDate = 'ION:NL:Cadastro:DadosPessoais:DataExpedicao';
        analyticsPage.gender = 'ION:NL:Cadastro:DadosPessoais:SexoAtribuidoNoNascimento';
        analyticsPage.nationality = 'ION:NL:Cadastro:DadosPessoais:Nacionalidade';
        analyticsPage.motherName = 'ION:NL:Cadastro:DadosPessoais:NomeDaMae';
    }

    private setContaionAnalyticsMarital(analyticsPage) {
        analyticsPage.maritalStatus = 'ION:NL:Cadastro:EstadoCivil:SeuEstadoCivil';
        analyticsPage.spouse = 'ION:NL:Cadastro:EstadoCivil:InformacoesConjuge';
    }

    private setContaionAnalyticsAddress(analyticsPage) {
        analyticsPage.cep = 'ION:NL:Cadastro:Endereco:CEP';
        analyticsPage.addressComplete = 'ION:NL:Cadastro:Endereco:CompleteEndereco';
    }

    private setContaionAnalyticsProfessiotal(analyticsPage) {
        analyticsPage.originIncome = 'ION:NL:Cadastro:DadosProfissionais:OrigemRendaOcupacao';
        analyticsPage.profession = 'ION:NL:Cadastro:DadosProfissionais:SuaProfissao';
        analyticsPage.companyInformation = 'ION:NL:Cadastro:DadosProfissionais:InformacoesEmpresa';
        analyticsPage.pep = 'ION:NL:Cadastro:DadosProfissionais:PessoaExpostaPoliticamente';
        analyticsPage.infoData = 'ION:NL:Cadastro:PorqueSolicitamosEssesDados';
    }

    private setContaionAnalyticsIncome(analyticsPage) {
        analyticsPage.income = 'ION:NL:Cadastro:RendaPatrimonio:RendaMensal';
        analyticsPage.patrimony = 'ION:NL:Cadastro:RendaPatrimonio:PatrimonioTotal';
        analyticsPage.taxResidency = 'ION:NL:Cadastro:RendaPatrimonio:ResidenciaFiscalNoBrasil';
        analyticsPage.taxResidencyCountry = 'ION:NL:Cadastro:RendaPatrimonio:QualPaisFicaSuaResidencialFiscal';
        analyticsPage.dateTaxResidency = 'ION:NL:Cadastro:RendaPatrimonio:InicioDaResidenciaFiscal';
        analyticsPage.nif = 'ION:NL:Cadastro:RendaPatrimonio:NumeroNIF';
    }

    private setContaionAnalyticsCommon(analyticsPage) {
        analyticsPage.action = 'CadastroContaIon'
        analyticsPage.back = 'BTN:Voltar',
        analyticsPage.continue = 'BTN:Continuar';
        analyticsPage.errorAPI = 'TentarNovamente';
    }

    private setBasicAnalyticsPersonal(analyticsPage) {
        analyticsPage.email = 'ION:LG:Cadastro:DadosPessoais:QualSeuEmail';
        analyticsPage.documentType = 'ION:LG:Cadastro:DadosPessoais:EscolhaDocumento';
        analyticsPage.documentName = 'ION:LG:Cadastro:DadosPessoais:InsiraSeuNome';
        analyticsPage.documentNumber = 'ION:LG:Cadastro:DadosPessoais:InsiraSeu';
        analyticsPage.documentIssuing = 'ION:LG:Cadastro:DadosPessoais:OrgaoExpedidor';
        analyticsPage.documentExpeditionState = 'ION:LG:Cadastro:DadosPessoais:EstadoExpedicao';
        analyticsPage.birthCity = 'ION:LG:Cadastro:DadosPessoais:CidadeQueNasceu';
        analyticsPage.birthCountry = 'ION:LG:Cadastro:DadosPessoais:PaisQueNasceu';
        analyticsPage.birthDate = 'ION:LG:Cadastro:DadosPessoais:QuandoNasceu';
        analyticsPage.birthState = 'ION:LG:Cadastro:DadosPessoais:EstadoQueNasceu';
        analyticsPage.documentExpeditionDate = 'ION:LG:Cadastro:DadosPessoais:DataExpedicao';
        analyticsPage.gender = 'ION:LG:Cadastro:DadosPessoais:SexoAtribuidoNoNascimento';
        analyticsPage.nationality = 'ION:LG:Cadastro:DadosPessoais:Nacionalidade';
        analyticsPage.motherName = 'ION:LG:Cadastro:DadosPessoais:NomeDaMae';
        analyticsPage.phoneNumber = 'ION:LG:Cadastro:DadosPessoais:QualSeuCelular';
        analyticsPage.name = 'ION:LG:Cadastro:DadosPessoais:NomeQueQuerUsar';
    }

    private setBasicAnalyticsMarital(analyticsPage) {
        analyticsPage.maritalStatus = 'ION:LG:Cadastro:EstadoCivil:SeuEstadoCivil';
        analyticsPage.spouse = 'ION:LG:Cadastro:EstadoCivil:InformacoesConjuge';
        analyticsPage.checkData = 'ION:LG:Cadastro:ChecagemDeDados';
    }

    private setBasicAnalyticsAddress(analyticsPage) {
        analyticsPage.cep = 'ION:LG:Cadastro:Endereco:CEP';
        analyticsPage.addressComplete = 'ION:LG:Cadastro:Endereco:CompleteEndereco';
        analyticsPage.addressName = 'ION:LG:Cadastro:Endereco:NomeRua';
        analyticsPage.addressNumber = 'ION:LG:Cadastro:Endereco:Numero';
        analyticsPage.addressState = 'ION:LG:Cadastro:Endereco:Estado';
        analyticsPage.addressCity = 'ION:LG:Cadastro:Endereco:Cidade';
        analyticsPage.addressDistrict = 'ION:LG:Cadastro:Endereco:Bairro';
        analyticsPage.addressAdjunct = 'ION:LG:Cadastro:Endereco:Complemento';
    }

    private setBasicAnalyticsProfessional(analyticsPage) {
        analyticsPage.originIncome = 'ION:LG:Cadastro:DadosProfissionais:OrigemRendaOcupacao';
        analyticsPage.profession = 'ION:LG:Cadastro:DadosProfissionais:SuaProfissao';
        analyticsPage.companyInformation = 'ION:LG:Cadastro:DadosProfissionais:InformacoesEmpresa';
        analyticsPage.income = 'ION:LG:Cadastro:RendaPatrimonio:RendaMensal';
        analyticsPage.patrimony = 'ION:LG:Cadastro:RendaPatrimonio:PatrimonioTotal';
        analyticsPage.taxResidency = 'ION:LG:Cadastro:RendaPatrimonio:ResidenciaFiscalNoBrasil';
        analyticsPage.taxResidencyCountry = 'ION:LG:Cadastro:RendaPatrimonio:QualPaisFicaSuaResidencialFiscal';
        analyticsPage.dateTaxResidency = 'ION:LG:Cadastro:RendaPatrimonio:InicioDaResidenciaFiscal';
        analyticsPage.nif = 'ION:LG:Cadastro:RendaPatrimonio:NumeroNIF';
    }

    private setBasicAnalyticsIncome(analyticsPage) {
        analyticsPage.income = 'ION:LG:Cadastro:RendaPatrimonio:RendaMensal';
        analyticsPage.patrimony = 'ION:LG:Cadastro:RendaPatrimonio:PatrimonioTotal';
        analyticsPage.taxResidency = 'ION:LG:Cadastro:RendaPatrimonio:ResidenciaFiscalNoBrasil';
        analyticsPage.taxResidencyCountry = 'ION:LG:Cadastro:RendaPatrimonio:QualPaisFicaSuaResidencialFiscal';
        analyticsPage.dateTaxResidency = 'ION:LG:Cadastro:RendaPatrimonio:InicioDaResidenciaFiscal';
        analyticsPage.nif = 'ION:LG:Cadastro:RendaPatrimonio:NumeroNIF';
    }

    private setBasicAnalyticsCommon(analyticsPage) {
        analyticsPage.action = 'CadastroInvestidor';
        analyticsPage.back = 'BTN:Voltar';
        analyticsPage.check = 'BTN:Checar';
        analyticsPage.knowMore = 'BTN:SaibaMais';
        analyticsPage.terms = 'ION:LG:Cadastro:FaltaPoucoParaInvestir:Termos';
        analyticsPage.broker = 'ION:LG:Cadastro:VinculoComItauCorretora';
        analyticsPage.relatedPerson = 'ION:LG:Cadastro:VinculoComItauCorretora:PessoasVinculadas';
        analyticsPage.dataAnalysisStatus = 'ION:LG:Cadastro:CadastroConcluido';
        analyticsPage.dataAnalysisStatusEvent = 'Sucesso';
        analyticsPage.dataAnalysisStatusLabel = 'CadastroEmAnalise';
        analyticsPage.brokerRegistration = 'ION:LG:Cadastro:ItauCorretora';
        analyticsPage.checkData = 'ION:LG:Cadastro:ChecagemDeDados';
        analyticsPage.data = 'ION:LG:Cadastro:ConferirSeusDados';
        analyticsPage.completeLater = 'BTN:CompletarDepois';
        analyticsPage.completeRegistration = 'BTN:CompletarCadastro';
        analyticsPage.enterData = 'ION:LG:Cadastro:InserirDados';
        analyticsPage.continueNewUser = 'BTN:Continuar';
        analyticsPage.errorAPI = 'TentarNovamente';
        analyticsPage.continue = 'BTN:Continuar';
    }

    private setUpdateRegistrationAnalyticsPersonal(analyticsPage) {
        analyticsPage.data = 'ION:LG:AtualizeCadastro:ConferirSeusDados';
        analyticsPage.email = 'ION:LG:AtualizeCadastro:DadosPessoais:QualSeuEmail';
        analyticsPage.documentType = 'ION:LG:AtualizeCadastro:DadosPessoais:EscolhaDocumento';
        analyticsPage.documentName = 'ION:LG:AtualizeCadastro:DadosPessoais:InsiraSeuNome';
        analyticsPage.documentNumber = 'ION:LG:AtualizeCadastro:DadosPessoais:InsiraSeu';
        analyticsPage.documentIssuing = 'ION:LG:AtualizeCadastro:DadosPessoais:OrgaoExpedidor';
        analyticsPage.documentExpeditionState = 'ION:LG:AtualizeCadastro:DadosPessoais:EstadoExpedicao';
        analyticsPage.birthCity = 'ION:LG:AtualizeCadastro:DadosPessoais:CidadeQueNasceu';
        analyticsPage.birthCountry = 'ION:LG:AtualizeCadastro:DadosPessoais:PaisQueNasceu';
        analyticsPage.birthDate = 'ION:LG:AtualizeCadastro:DadosPessoais:QuandoNasceu';
        analyticsPage.birthState = 'ION:LG:AtualizeCadastro:DadosPessoais:EstadoQueNasceu';
        analyticsPage.documentExpeditionDate = 'ION:LG:AtualizeCadastro:DadosPessoais:DataExpedicao';
        analyticsPage.gender = 'ION:LG:AtualizeCadastro:DadosPessoais:SexoAtribuidoNoNascimento';
        analyticsPage.nationality = 'ION:LG:AtualizeCadastro:DadosPessoais:Nacionalidade';
        analyticsPage.motherName = 'ION:LG:AtualizeCadastro:DadosPessoais:NomeDaMae';
        analyticsPage.checkData = 'ION:LG:AtualizeCadastro:ChecagemDeDados';
        analyticsPage.phoneNumber = 'ION:LG:AtualizeCadastro:DadosPessoais:QualSeuCelular';
        analyticsPage.name = 'ION:LG:AtualizeCadastro:DadosPessoais:NomeQueQuerUsar';
    }

    private setUpdateRegistrationAnalyticsMarital(analyticsPage) {
        analyticsPage.data = 'ION:LG:AtualizeCadastro:ConferirSeusDados';
        analyticsPage.maritalStatus = 'ION:LG:AtualizeCadastro:EstadoCivil:SeuEstadoCivil';
        analyticsPage.spouse = 'ION:LG:AtualizeCadastro:EstadoCivil:InformacoesConjuge';
        analyticsPage.checkData = 'ION:LG:AtualizeCadastro:ChecagemDeDados';
    }

    private setUpdateRegistrationAnalyticsAddress(analyticsPage) {
        analyticsPage.data = 'ION:LG:AtualizeCadastro:ConferirSeusDados';
        analyticsPage.cep = 'ION:LG:AtualizeCadastro:Endereco:CEP';
        analyticsPage.addressComplete = 'ION:LG:AtualizeCadastro:Endereco:CompleteEndereco';
        analyticsPage.checkData = 'ION:LG:AtualizeCadastro:ChecagemDeDados';
    }

    private setUpdateRegistrationAnalyticsProfessional(analyticsPage) {
        analyticsPage.data = 'ION:LG:AtualizeCadastro:ConferirSeusDados';
        analyticsPage.originIncome = 'ION:LG:AtualizeCadastro:DadosProfissionais:OrigemRendaOcupacao';
        analyticsPage.profession = 'ION:LG:AtualizeCadastro:DadosProfissionais:SuaProfissao';
        analyticsPage.companyInformation = 'ION:LG:AtualizeCadastro:DadosProfissionais:InformacoesEmpresa';
        analyticsPage.checkData = 'ION:LG:AtualizeCadastro:ChecagemDeDados';
        analyticsPage.data = 'ION:LG:AtualizeCadastro:ConferirSeusDados';
        analyticsPage.income = 'ION:LG:AtualizeCadastro:RendaPatrimonio:RendaMensal';
        analyticsPage.patrimony = 'ION:LG:AtualizeCadastro:RendaPatrimonio:PatrimonioTotal';
        analyticsPage.taxResidency = 'ION:LG:AtualizeCadastro:RendaPatrimonio:ResidenciaFiscalNoBrasil';
        analyticsPage.taxResidencyCountry = 'ION:LG:AtualizeCadastro:RendaPatrimonio:QualPaisFicaSuaResidencialFiscal';
        analyticsPage.dateTaxResidency = 'ION:LG:AtualizeCadastro:RendaPatrimonio:InicioDaResidenciaFiscal';
        analyticsPage.nif = 'ION:LG:AtualizeCadastro:RendaPatrimonio:NumeroNIF';
        analyticsPage.checkData = 'ION:LG:AtualizeCadastro:ChecagemDeDados';
    }

    private setUpdateRegistrationAnalyticsIncome(analyticsPage) {
        analyticsPage.data = 'ION:LG:AtualizeCadastro:ConferirSeusDados';
        analyticsPage.income = 'ION:LG:AtualizeCadastro:RendaPatrimonio:RendaMensal';
        analyticsPage.patrimony = 'ION:LG:AtualizeCadastro:RendaPatrimonio:PatrimonioTotal';
        analyticsPage.taxResidency = 'ION:LG:AtualizeCadastro:RendaPatrimonio:ResidenciaFiscalNoBrasil';
        analyticsPage.taxResidencyCountry = 'ION:LG:AtualizeCadastro:RendaPatrimonio:QualPaisFicaSuaResidencialFiscal';
        analyticsPage.dateTaxResidency = 'ION:LG:AtualizeCadastro:RendaPatrimonio:InicioDaResidenciaFiscal';
        analyticsPage.nif = 'ION:LG:AtualizeCadastro:RendaPatrimonio:NumeroNIF';
        analyticsPage.checkData = 'ION:LG:AtualizeCadastro:ChecagemDeDados';
    }

    private setUpdateRegistrationAnalyticsCommon(analyticsPage) {
        analyticsPage.action = 'AtualizeCadastro';
        analyticsPage.actionClose = 'Perfil';
        analyticsPage.back = 'BTN:Voltar';
        analyticsPage.close = 'BTN:Fechar';
        analyticsPage.check = 'BTN:Checar';
        analyticsPage.knowMore = 'BTN:SaibaMais';
        analyticsPage.continue = 'BTN:Continuar';
        analyticsPage.dataAnalysisStatus = 'ION:LG:AtualizeCadastro:CadastroConcluido';
        analyticsPage.dataAnalysisStatusEvent = 'Sucesso';
        analyticsPage.dataAnalysisStatusLabel = 'CadastroEmAnalise';
        analyticsPage.terms = 'ION:LG:AtualizeCadastro:FaltaPoucoParaInvestir:Termos';
        analyticsPage.broker = 'ION:LG:AtualizeCadastro:VinculoComItauCorretora';
        analyticsPage.relatedPerson = 'ION:LG:AtualizeCadastro:VinculoComItauCorretora:PessoasVinculadas';
        analyticsPage.brokerRegistration = 'ION:LG:AtualizeCadastro:ItauCorretora';
        analyticsPage.errorAPI = 'TentarNovamente';
    }
}


